import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import ServicePageContent from '../sections/ServicePage/ServicePageContent';


const ServicesPage = () =>{
    return (
        <>
            <Navbar />
            <ServicePageContent />
            <Footer />
        </>
    );
}

export default ServicesPage;